import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCuttingPlanStore } from '../../stores/cuttingPlanStore';

const PreCutRebarTable = ({
    showDisableButtons = false,
}) => {
    const { t } = useTranslation();

    const allPatterns = useCuttingPlanStore(state => state.allPatterns);
    const rebarInformation = useCuttingPlanStore(state => state.rebarInformation);
    const makePatternNotPreCut = useCuttingPlanStore(state => state.makePatternNotPreCut);
    const removeSelectedPreCutPatterns = useCuttingPlanStore(state => state.removeSelectedPreCutPatterns);

    const showedPatterns = allPatterns.filter(pattern => pattern.show);

    const preCutPatterns = showedPatterns.filter(pattern => pattern.preCut);

    const showRemoveAllButtons = showDisableButtons && preCutPatterns.length > 1;

    const getPreCutRebars = (pattern) => {
        let preCutRebarsOfPattern = [];
        if ("substitutions" in pattern) {
            const substitutions = pattern.substitutions;
            preCutRebarsOfPattern = preCutRebarsOfPattern.concat(substitutions.map((substitution, j) => ({
                diameter: pattern.diameter,
                element: substitution.actual,
                count: substitution.number,
                cutLength: substitution.subs_by,

                patternNo: pattern.patternNo,
                floor: rebarInformation[substitution.actual]["kat"],
                structureElement: rebarInformation[substitution.actual]["yapiElemani"],
                structureElementCode: rebarInformation[substitution.actual]["yapiElemaniKodu"],
                explanation: rebarInformation[substitution.actual]["aciklama"],
                pose: rebarInformation[substitution.actual]["poz"],
                rebarCode: rebarInformation[substitution.actual]["donatiKodu"]
            })))
        }
        preCutRebarsOfPattern = preCutRebarsOfPattern
            .concat(Object.entries(pattern.elements)
                .map((element, j) => ({
                    diameter: pattern.diameter,
                    element: element[0],
                    count: element[1],
                    cutLength: element[0].split("-")[1],
                    patternNo: pattern.patternNo,
                    floor: rebarInformation[element[0]]["kat"],
                    structureElement: rebarInformation[element[0]]["yapiElemani"],
                    structureElementCode: rebarInformation[element[0]]["yapiElemaniKodu"],
                    explanation: rebarInformation[element[0]]["aciklama"],
                    pose: rebarInformation[element[0]]["poz"],
                    rebarCode: rebarInformation[element[0]]["donatiKodu"]
                })));

        return preCutRebarsOfPattern.sort((a, b) => b.cutLength - a.cutLength);
    };

    return (
        <div className='table-responsive'>
            {preCutPatterns.length === 0 ?
                <div className="alert alert-secondary text-center" role="alert">
                    {t("Hazır kesimli donatı bulunmamaktadır.")}
                </div>
            :
            <table className="table table-sm border table-bordered text-center align-middle">
                <thead>
                    <tr className='align-middle'>
                        <th scope="col">{t("Kesim No.")}</th>
                        <th scope="col">{t("Uzunluk")} (cm)</th>
                        <th scope="col">{t("Adet")}</th>
                        <th scope="col">{t("Çap")}</th>
                        <th scope="col">{t("Kat")}</th>
                        <th scope="col">{t("Yapı Elemanı")}</th>
                        <th scope="col">{t("Eleman İsmi")}</th>
                        <th scope="col">{t("Açıklama")}</th>
                        <th scope="col">{t("Poz")}</th>
                        <th scope="col">{t("Donatı Kodu")}</th>
                        {showRemoveAllButtons &&
                            <th scope="col">
                                <button
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => removeSelectedPreCutPatterns()}
                                >
                                    {t("Tümünü Temizle")}
                                </button>
                            </th>
                        }
                    </tr>
                </thead>
                <tbody>
                    {preCutPatterns
                        .sort((a, b) => a.patternNo - b.patternNo)
                        .map((pattern, i) => {
                            const preCutRebars = getPreCutRebars(pattern);

                            return (
                                <>
                                    <tr key={`pattern-header-${i}`}>
                                        <td rowSpan={preCutRebars.length}>{pattern.patternNo}</td>
                                        <td>{preCutRebars[0].cutLength}</td>
                                        <td>{preCutRebars[0].count}</td>
                                        <td>{preCutRebars[0].diameter}</td>
                                        <td>{preCutRebars[0].floor}</td>
                                        <td>{preCutRebars[0].structureElement}</td>
                                        <td>{preCutRebars[0].structureElementCode}</td>
                                        <td>{preCutRebars[0].explanation}</td>
                                        <td>{preCutRebars[0].pose}</td>
                                        <td>{preCutRebars[0].rebarCode}</td>
                                        {showDisableButtons &&
                                            <td
                                                rowSpan={preCutRebars.length}
                                            >
                                                <button
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => makePatternNotPreCut(pattern.patternNo)}
                                                >
                                                    {t("Kesimi Temizle")}
                                                </button>
                                            </td>
                                        }
                                    </tr>
                                    {preCutRebars.slice(1).map((rebar, j) => (
                                        <tr key={`pattern-rebar-${i}-${j}`}>
                                            <td>{rebar.cutLength}</td>
                                            <td>{rebar.count}</td>
                                            <td>{rebar.diameter}</td>
                                            <td>{rebar.floor}</td>
                                            <td>{rebar.structureElement}</td>
                                            <td>{rebar.structureElementCode}</td>
                                            <td>{rebar.explanation}</td>
                                            <td>{rebar.pose}</td>
                                            <td>{rebar.rebarCode}</td>
                                        </tr>
                                    ))}
                                </>
                            );
                        })}
                </tbody>
            </table>}
        </div >
    );
}

export default PreCutRebarTable;